
import { Vue, Component, Watch } from "vue-property-decorator"
import api from "../honcierge-api"
import EditDialog from "@/components/SpecialFeatures/EditDialog.vue"
import TableItemIsEnabled from "@/components/_share/TableItemIsEnabled.vue"
import { AxiosError } from "axios"
import { ArticleSearchMaster, SpecialFeature } from "types/index"
import { DataTableHeader } from "vuetify/types"

@Component({ components: { EditDialog, TableItemIsEnabled } })
export default class SpecialFeatures extends Vue {
  get headers(): DataTableHeader[] {
    return [
      { text: "優先度", value: "priority" },
      { text: "タイトル", value: "title" },
      { text: "URL", value: "urlKey" },
      { text: "概要文", value: "overview" },
      { text: "トップページに表示", value: "showOnTop" },
      { text: "タイトルを表示", value: "showTitle" },
      { text: "有効/無効", value: "isEnabled" },
      { text: "バナー", value: "banner", sortable: false },
      { text: "操作", value: "action", sortable: false },
    ]
  }

  private loading = true
  private dialog = false
  private specialFeatures: SpecialFeature["data"][] = []
  private isEnabledFilters: Array<{ name: string; isEnabled?: boolean }> = [
    { name: "絞り込みなし", isEnabled: undefined },
    { name: "有効", isEnabled: true },
    { name: "無効", isEnabled: false },
  ]
  private showOnTopFilters: Array<{ name: string; showOnTop?: boolean }> = [
    { name: "絞り込みなし", showOnTop: undefined },
    { name: "トップページに表示", showOnTop: true },
    { name: "トップページに表示しない", showOnTop: false },
  ]
  private showTitleFilters: Array<{ name: string; showTitle?: boolean }> = [
    { name: "絞り込みなし", showTitle: undefined },
    { name: "表示", showTitle: true },
    { name: "非表示", showTitle: false },
  ]
  private selectedFilter: {
    name: string
    isEnabled?: boolean
    showOnTop?: boolean
    showTitle?: boolean
  } = { name: "絞り込みなし" }
  private articleSearchMaster: ArticleSearchMaster["searchMaster"] = {
    statuses: [],
    editors: [],
    writers: [],
    categories: [],
    appAffiliates: [],
  }

  private totalPages = 0
  private pagination = {
    sortBy: ["priority"],
    sortDesc: [true],
    itemsPerPage: -1,
    page: 1,
  }

  public created(): void {
    this.loading = false
    this.getSpecialFeatures()
    this.getArticleSearchMaster()
  }

  private getArticleSearchMaster() {
    api
      .adminSearchMasters()
      .then((res) => {
        const result = res.data.searchMaster
        this.articleSearchMaster.statuses = result.articleStatuses
        this.articleSearchMaster.editors = result.editors
        this.articleSearchMaster.writers = result.writers
        this.articleSearchMaster.categories = result.categories
        this.articleSearchMaster.appAffiliates = result.appAffiliates
      })
      .catch((e: AxiosError) => {
        console.log(e.stack)
      })
  }

  @Watch("pagination.page", { deep: true, immediate: true })
  private onChangePage() {
    this.loading = true
    setTimeout(() => {
      this.getSpecialFeatures()
      this.loading = false
    }, 500)
  }

  private getSpecialFeatures(_page?: number) {
    const isEnabled = this.selectedFilter.isEnabled
    const showOnTop = this.selectedFilter.showOnTop
    const showTitle = this.selectedFilter.showTitle
    const page = _page ? _page : this.pagination.page
    const per = 10
    const sortBy = this.pagination.sortBy[0]
    const descending = this.pagination.sortDesc[0]
    const excludeSpecialFeatureIds: number[] = []
    const includes = [
      "id",
      "priority",
      "title",
      "url_key",
      "overview",
      "show_on_top",
      "show_title",
      "is_enabled",
      "created_at",
      "updated_at",
    ]

    api
      .getSpecialFeatures({
        showOnTop,
        isEnabled,
        showTitle,
        page,
        per,
        sortBy,
        descending,
        excludeSpecialFeatureIds,
        includes,
      })
      .then((res) => {
        this.totalPages = res.data.meta.totalPages
        this.specialFeatures = res.data.specialFeatures
      })
      .catch(() => {
        this.$toasted.error("特集一覧の取得に失敗しました")
      })
  }

  private search() {
    this.resetPagination()
    this.getSpecialFeatures()
  }

  private resetPagination() {
    this.pagination.page = 1
  }

  private createSpecialFeature() {
    if (this.pagination.page > 1) {
      this.pagination.page = 1 // Watchされていることに注意
    } else {
      this.getSpecialFeatures()
    }
    this.$toasted.success("特集を新規作成しました")
  }

  private updateSpecialFeature(page: number) {
    this.getSpecialFeatures(page)
    this.$toasted.success("特集を更新しました")
  }

  private deleteSpecialFeature(page: number) {
    this.getSpecialFeatures(page)
    this.$toasted.success("特集を削除しました")
  }

  private async open(id?: number) {
    if (id) {
      const refs = this.$refs[id] as InstanceType<typeof EditDialog>
      if (Array.isArray(refs)) {
        refs[0].open()
      } else {
        refs.open()
      }
    } else {
      const newDialog = this.$refs.newDialog as InstanceType<typeof EditDialog>
      newDialog.open()
    }
  }

  private existBanner(banner: { filename: string; url: string }): boolean {
    return banner.filename !== null && banner.url !== null
  }
}
